import { Controller } from "@hotwired/stimulus"

// Phone layout for the conversations inbox. Desktop shows list, chat and CRM
// sidebar side by side; a phone shows one pane at a time — the list, or the
// open conversation with a back button — and the CRM sidebar as a drawer.
// Which pane is visible is a data attribute the stylesheet reads, so the DOM
// (and the list's scroll position) is untouched by the switch.
export default class extends Controller {
  static targets = ["sidebar", "backdrop"]
  static values = { pane: String, listUrl: String }

  connect() {
    // "Marcar como no leído" lands the panel on its empty state: on a phone
    // that means going back to the list, not staring at "Selecciona…".
    this.frameLoadHandler = (event) => {
      if (event.target.id !== "conversation_panel") return
      const src = event.target.getAttribute("src") || ""
      if (!/\/admin\/conversations\/\d+/.test(src)) this.showList()
    }
    this.element.addEventListener("turbo:frame-load", this.frameLoadHandler)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.frameLoadHandler)
  }

  paneValueChanged() {
    this.element.dataset.inboxPane = this.paneValue || "list"
  }

  // Clicking a conversation (list or search results) opens the chat pane.
  itemClicked(event) {
    if (event.target.closest("a.conversation-item")) this.showPanel()
  }

  showPanel() {
    this.paneValue = "panel"
  }

  showList() {
    this.closeSidebar()
    this.paneValue = "list"
    // The frame navigation advanced the URL to the conversation; a reload
    // should bring the list back, not reopen (and re-read) that conversation.
    if (this.listUrlValue && window.location.pathname !== this.listUrlValue) {
      history.replaceState(history.state, "", this.listUrlValue)
    }
  }

  toggleSidebar() {
    if (!this.hasSidebarTarget) return
    const open = this.sidebarTarget.classList.contains("hidden")
    this.sidebarTarget.classList.toggle("hidden", !open)
    if (this.hasBackdropTarget) this.backdropTarget.classList.toggle("hidden", !open)
  }

  closeSidebar() {
    if (this.hasSidebarTarget) this.sidebarTarget.classList.add("hidden")
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("hidden")
  }
}
